import * as React from 'react';
import { Form, Input } from 'semantic-ui-react';

export interface Datos {
    id: string;
    otro: string;
}

export const inicial: Datos = {
    id: '',
    otro: '',
};

interface Props {
    select: {
        etiqueta: string;
        opciones: Array<{ value: string; text: string }>;
        requerido?: boolean;
    };
    input: {
        etiqueta: string;
        mostrar(): boolean;
    };
    valor: Datos;
    onChange(valor: Datos): void;
}

const SeleccionableOtro: React.FunctionComponent<Props> = props => {
    const { select, input, valor, onChange } = props;

    return (
        <Form.Group>
            <Form.Select
                label={select.etiqueta}
                options={select.opciones}
                placeholder='Seleccione'
                required={select.requerido || false}
                value={valor.id}
                onChange={(_e, { value }) => {
                    onChange({
                        ...valor,
                        id: (value as string) || '',
                    });
                }}
                width='5'
            />

            <Form.Field width='11' hidden={!input.mostrar()} required={input.mostrar()}>
                <label>{input.etiqueta}</label>
                <Input
                    required={input.mostrar()}
                    value={valor.otro}
                    onChange={(_e, { value }) => {
                        onChange({
                            ...valor,
                            otro: value,
                        });
                    }}
                />
            </Form.Field>
        </Form.Group>
    );
};

export default SeleccionableOtro;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/SeleccionableOtro/index.tsx